import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectService} from '../../../../shared/services/project.service';
import {Subject, Subscription} from 'rxjs';
import {Extras} from '../../../../shared/models/extras.enum';
import {Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {CmsService} from '../../../../cms/services/cms.service';
import { UrlSites } from 'src/app/enums/url-sites.enum';

@Component({
  selector: 'app-home-newsletter',
  templateUrl: './home-newsletter.component.html',
  styleUrls: ['./home-newsletter.component.scss']
})
export class HomeNewsletterComponent implements OnInit, OnDestroy {
  showRedirectBanner: boolean;

  constructor(private _projectService: ProjectService,
              private _cmsService: CmsService,
              private _router: Router) {
  }

  private unsubscribe$ = new Subject<any>();

  extrasSubscription: Subscription;
  hasNewsletter: boolean;
  email: string;

  ngOnInit(): void {
    this.showRedirectBanner = false;

    this._cmsService.siteUrl$.pipe(takeUntil(this.unsubscribe$)).subscribe(siteUrl => {
      if (siteUrl) {
        if (siteUrl.includes(UrlSites.GEOTN) || siteUrl.includes(UrlSites.VACANZEWELCOMETRAVEL)) {
          this.showRedirectBanner = true;
          this.hasNewsletter = true;
        } else {
          this.showRedirectBanner = false;

          this.hasNewsletter = false;
        }
      }
    });
    this.extrasSubscription = this._projectService.getServicesFromProject().subscribe(e => {
      if (e) {
        e.forEach(x => {
          if (x.service_code === Extras.NEWSLETTER_B2C_CRM_GEO || x.service_code === Extras.NEWSLETTER_B2C_WELCOME_TRAVEL || x.service_code === Extras.NEWSLETTER_B2C) {
            this.hasNewsletter = true;
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.extrasSubscription?.unsubscribe();
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  goToNewsLetter(): void {
    this._router.navigate(['newsletter'], {queryParams: {email: this.email}});
  }

}
